<template>
    <v-tooltip top color="white">
        <template #activator="{ on, attrs }">
            <v-img
                :src="getIcon()"
                :max-height="size"
                :max-width="size"
                contain
                v-bind="attrs"
                class=""
                :style="filtersInvert"
                v-on="on"
                @click.native.stop
            >
            </v-img>
            <span v-if="delayTime" class="ml-1" :style="filtersInvert">
                {{ delayTime }}
            </span>
        </template>
        <span class="d-flex">
            <v-img
                :src="getIcon()"
                :max-height="size"
                :max-width="size"
                class="mr-2"
                contain
            >
            </v-img>
            <span v-if="delayTime">
                {{ delayTime }}
            </span>
            <span v-if="maxCommission" class="black--text">
                Commission given upto {{ maxCommission | currencyFormat(0) }}
                <span v-if="textCommission">
                    | No Commission below 20 paise.
                </span>
            </span>
            <span v-if="!maxCommission && !delayTime" class="black--text">
                {{ text }}
            </span>
            <!-- <span v-if="maxCommission || text" class="black--text">
        {{ text }}
      </span> -->
        </span>
    </v-tooltip>
</template>

<script>
export default {
    name: "PlayIcon",
    props: {
        name: { type: String, default: "commission", required: true },
        text: { type: String, default: "Commission", required: true },
        maxCommission: {
            type: Number,
            required: false
        },
        filtersInvert: {
            type: String,
            default: "filter: brightness(0) invert(1)"
        },
        textCommission: {
            type: Boolean,
            required: false
        },
        delayTime: {
            type: Number,
            required: false
        },
        size: { type: Number, default: 15, required: false },
        type: { type: String, default: "png", required: false }
    },
    data() {
        return {}
    },
    methods: {
        getIcon() {
            try {
                return require(`@/assets/playicons/${this.name}.${this.type}`)
            } catch (error) {
                return ""
            }
        }
    }
}
</script>
